import { useMutation } from "react-query";
import { getSecurityByRecordNumbers } from "../../../../actions/CarrierAgreementMgmt/Security";

const useSecurityForDownload = () => {
  return useMutation(getSecurityByRecordNumbers);
};
export default useSecurityForDownload;
